import { useEffect, useState } from "react";

const LandingBeforeContent = () => {
  const COLORS = {
    primaryGreen: "#5ec250",
  };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const styles = {
    container: {
      maxWidth: "1100px",
      margin: "0 auto",
      padding: isMobile ? "40px 16px" : "60px 20px",
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      overflowX: "hidden",
    },

    title: {
      textAlign: "center",
      fontSize: "clamp(26px, 4vw, 44px)",
      fontWeight: 500,
      lineHeight: 1.2,
      marginBottom: isMobile ? "30px" : "50px",
    },

    highlight: { color: COLORS.primaryGreen },

    /* ================= SECTION 1 ================= */
    sectionOne: {
      display: "flex",
      gap: "40px",
      flexWrap: "wrap",
      flexDirection: isMobile ? "column" : "row",
      alignItems: "center",
    },

    leftImageWrap: {
      flex: "1 1 420px",
      display: "flex",
      justifyContent: "center",
    },

    imageStack: {
      position: "relative",
      width: "100%",
      maxWidth: isMobile ? "280px" : "420px",
    },

    imageTiltShade: {
      position: "absolute",
      top: isMobile ? "8px" : "12px",
      left: isMobile ? "15px" : "36px",
      transform: isMobile ? "rotate(2deg)" : "rotate(5deg)",
      width: "100%",
      height: isMobile ? "84%" : "100%",
      background: "#e5e5e5",
      borderRadius: "38px",
      zIndex: 0,
    },

    leftImage: {
      position: "relative",
      width: "100%",
      borderRadius: "35px",
      zIndex: 1,
    },

    rightContent: {
      marginTop: isMobile ? "-65px" : "",
      flex: "1 1 480px",
      display: "flex",
      flexDirection: "column",
      textAlign: isMobile ? "center" : "left",
    },

    description: {
      fontSize: isMobile ? "16px" : "20px",
      lineHeight: 1.8,
      color: "#555",
      marginBottom: "25px",
    },

    bottomRow: {
      display: "flex",
      gap: "20px",
      flexDirection: isMobile ? "column" : "row",
      alignItems: "center",
    },

    highlightCard: {
      background: "#3b3b3b",
      color: "#fff",
      padding: "20px",
      borderRadius: "16px",
      fontSize: isMobile ? "16px" : "18px",
      lineHeight: 1.6,
      width: isMobile ? "88%" : "100%",
    },

    smallImage: {
      width: isMobile ? "100%" : "200px",
      maxWidth: "320px",
      borderRadius: "16px",
      objectFit: "cover",
    },

    /* ================= SECTION 2 ================= */
    sectionTwo: {
      display: "flex",
      gap: "40px",
      marginTop: "50px",
      flexWrap: "wrap",
      flexDirection: isMobile ? "column" : "row",
      alignItems: "center",
    },

    modernLeft: {
      flex: "1 1 420px",
      display: "flex",
      flexDirection: "column",
      gap: "18px",
      textAlign: isMobile ? "center" : "left",
    },

    modernTitle: {
      fontSize: isMobile ? "22px" : "26px",
      fontWeight: 500,
      lineHeight: 1.3,
    },

    modernLeftCard: {
      background: "#f1fbf4",
      borderRadius: "22px",
      padding: "18px",
    },

    modernImage: {
      width: "100%",
      borderRadius: "18px",
      marginBottom: "14px",
    },

    modernCaption: {
      fontSize: isMobile ? "16px" : "18px",
      lineHeight: 1.6,
      color: "#333",
    },

    modernRight: {
      flex: "1 1 520px",
      display: "flex",
      flexDirection: "column",
      textAlign: isMobile ? "center" : "left",
    },

    modernDesc: {
      fontSize: isMobile ? "16px" : "20px",
      lineHeight: 1.7,
      color: "#555",
      marginBottom: "26px",
    },

    featureGrid: {
      display: "grid",
      gridTemplateColumns: isMobile
        ? "repeat(auto-fit, minmax(140px, 1fr))"
        : "repeat(2, 1fr)",
      gap: "16px",
      justifyItems: "center",
      marginBottom: "28px",
    },

    featureCard: {
      border: "1px solid #eee",
      borderRadius: "18px",
      padding: "20px",
      width: "100%",
      maxWidth: isMobile ? "120px" : "180px",
      textAlign: "center",
      background: "#fff",
      fontSize: isMobile ? "15px" : "18px",
    },

    featureCardActive: {
      background: COLORS.primaryGreen,
      color: "#fff",
      borderRadius: "18px",
      padding: "20px",
      width: "100%",
      maxWidth: isMobile ? "120px" : "180px",
      textAlign: "center",
      fontSize: isMobile ? "15px" : "18px",
    },

    featureIcon: {
      width: "46px",
      height: "46px",
      borderRadius: "50%",
      background: "#e9f8ee",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      margin: "0 auto 8px",
    },

    featureIconActive: {
      background: "#fff",
    },

    iconImg: {
      width: "36px",
      objectFit: "contain",
    },

    footerText: {
      fontSize: isMobile ? "16px" : "20px",
      lineHeight: 1.7,
      color: "#555",
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>
        Apartments for Sale in Trichy
      </h1>

      {/* SECTION 1 */}
      <div style={styles.sectionOne}>
        <div style={styles.leftImageWrap}>
          <div style={styles.imageStack}>
            <div style={styles.imageTiltShade} />
            <img
              src="https://mithahomes.com/backend/uploads/home/image2.png"
              alt="Apartment"
              style={styles.leftImage}
            />
          </div>
        </div>

        <div style={styles.rightContent}>
          <p style={styles.description}>
            {/* <strong>Find Your Dream 3 BHK Apartments in Trichy</strong><br /><br /> */}
            Explore premium apartments for sale in Trichy with modern amenities, spacious floor plans, and prime locations by Mitha Homes. Discover quality Apartment sale in Trichy designed for comfortable family living and long-term investment value.
          </p>

          <div style={styles.bottomRow}>
            <div style={styles.highlightCard}>
              <strong>High budget Apartments – Designed for Modern Living</strong><br /><br />
              Luxury Apartments in Trichy for Comfortable Living <br />
              Upgrade your lifestyle with our luxury apartments for sale in Trichy, built for families who seek comfort and elegance. From smart layouts to premium finishes, Mitha Homes ensures every apartment reflects quality and sophistication.
            </div>

            <img
              src="https://mithahomes.com/backend/uploads/home/image3.png"
              alt="Building"
              style={styles.smallImage}
            />
          </div>
        </div>
      </div>

      {/* SECTION 2 */}
      <div style={styles.sectionTwo}>
        <div style={styles.modernLeft}>
          <h2 style={styles.modernTitle}>
            3 BHK Apartments for Sale in Trichy <br />
            {/* <span style={{ color: COLORS.primaryGreen }}>
              Book Your Dream Home Today
            </span> */}
          </h2>

          <div style={styles.modernLeftCard}>
            <img
              src="https://mithahomes.com/backend/uploads/home/image4.png"
              alt="Apartment Project"
              style={styles.modernImage}
            />
            <p style={styles.modernCaption}>
              Explore our latest projects offering new premium properties with flexible pricing and easy booking options.
              Whether you're a first-time buyer or investor, our properties provide excellent long-term value.
            </p>
          </div>
        </div>

        <div style={styles.modernRight}>
          <p style={styles.modernDesc}>
            <strong>Premium Apartments with Top Amenities</strong><br />
            Our 3 bhk apartment sale in Trichy projects are designed to give you more than just a home – a complete lifestyle.
          </p>

          <div style={styles.featureGrid}>
            <div style={styles.listItem}>• Prime city locations with excellent connectivity</div>
            <div style={styles.listItem}>• Modern architecture and high-quality construction</div>
            <div style={styles.listItem}>• 24/7 security and gated community living</div>
            <div style={styles.listItem}>• Ample parking space</div>
            <div style={styles.listItem}>• Children’s play area & landscaped surroundings</div>
            <div style={styles.listItem}>• Close to schools, hospitals, and shopping centers</div>
          </div>

          <p style={styles.footerText}>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LandingBeforeContent;
